import React from 'react';
import { useTable } from 'react-table';
import './Table.css' ;
import { data } from './Data/SalaryData';

const Table2 = () => {
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "First Name",
        accessor: "first_name",
      },
      {
        Header: "Last Name",
        accessor: "last_name",
      },
      {
        Header: "Basic",
        accessor: "Basic",
      },
      {
        Header: "Grosspay",
        accessor: "Grosspay",
      },
      {
        Header: "Housing",
        accessor: "Housing",
      },
      {
        Header:"Others",
        accessor: "Others"
      },
      
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data });

  return (
    <div className="App">
      <div className="table-container">
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className={row.original.first_name.toLowerCase()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>
                      {cell.column.id === 'first_name' ? (
                        <div className='firstName'>
                          <span className='first_letters'>
                            {cell.row.original.first_name.charAt(0) + cell.row.original.last_name.charAt(0)}
                          </span>
                          {cell.render("Cell")}
                        </div>
                      ) : cell.column.id === 'status' ? (
                        <span className={`${cell.row.original.status === "Active" ? 'active' : cell.row.original.status === "Pending" ? 'pending' : 'unactive'}`}>{cell.render("Cell")}</span>
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
            ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default Table2;
